module.exports = __webpack_public_path__ + "static/media/11.4d199a13.jpg";